'use client'

import classNames from 'classnames'
import Image from 'next/image'
import React from 'react'

import pngImage from '~/assets/brazauk-logo-preto.png'

interface Properties {
  className?: string
}

const HeaderSvg: React.FC<Properties> = ({}) => {
  return (
    <div>
      <Image
        src={pngImage}
        alt="Description of the image"
        className="absolute max-h-40 max-w-48 top-8 left-8"
      />
    </div>
  )
}

export default HeaderSvg
